import { createApp } from 'vue';
import PoliticiansApp from './politicians/PoliticiansApp.vue';

export default function initFindPersonBlock() {
    [].slice.apply(document.querySelectorAll('[data-app-name="politicians"]')).forEach(initBlock);
}

/**
 * @param {HTMLElement} root
 */
function initBlock(root) {
    const props = JSON.parse(root.dataset.props || '{}');
    const app = createApp(PoliticiansApp, props);
    app.mount(root);
}
